import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ui-page" }
const _hoisted_2 = { class: "titlebar" }
const _hoisted_3 = { class: "titlebar-content" }
const _hoisted_4 = { class: "titlebar-title --mobile" }
const _hoisted_5 = { class: "titlebar-text" }
const _hoisted_6 = { class: "titlebar-actions" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "titlebar-actions-secondary" }, null, -1)
const _hoisted_8 = { class: "titlebar-actions-primary" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Salvar")
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "ui-card" }
const _hoisted_12 = { class: "ui-card-body" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_18 = { class: "ui-card ui-mt-30" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ui-header-content-title" }, [
      /*#__PURE__*/_createElementVNode("h4", { class: "ui-card-title" }, [
        /*#__PURE__*/_createElementVNode("span", null, "Dados Principais")
      ])
    ])
  ])
], -1)
const _hoisted_20 = { class: "ui-card-body" }
const _hoisted_21 = { class: "ant-row" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_23 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-5"
}
const _hoisted_24 = {
  key: 1,
  class: "ant-col ant-col-xs-24 ant-col-xl-5"
}
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-15" }
const _hoisted_26 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_28 = { class: "ant-row" }
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_30 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_31 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_32 = { class: "ant-row" }
const _hoisted_33 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_34 = { class: "ui-card ui-mt-30" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ui-header-content-title" }, [
      /*#__PURE__*/_createElementVNode("h4", { class: "ui-card-title" }, [
        /*#__PURE__*/_createElementVNode("span", null, "Endereço/Localização")
      ])
    ])
  ])
], -1)
const _hoisted_36 = { class: "ui-card-body" }
const _hoisted_37 = { class: "ant-row" }
const _hoisted_38 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_39 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_40 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_41 = { class: "ant-row" }
const _hoisted_42 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_43 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_44 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_combo_tipo_pessoa = _resolveComponent("combo-tipo-pessoa")!
  const _component_campo_cpf = _resolveComponent("campo-cpf")!
  const _component_campo_cnpj = _resolveComponent("campo-cnpj")!
  const _component_campo_email = _resolveComponent("campo-email")!
  const _component_campo_telefone = _resolveComponent("campo-telefone")!
  const _component_campo_cep = _resolveComponent("campo-cep")!
  const _component_combo_cidade = _resolveComponent("combo-cidade")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.appBase.titulo), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "ui-button -primary",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.salvar()))
          }, _hoisted_10)
        ])
      ])
    ]),
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.appBase.carregando
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_a_form_item, { label: "Identificação/Nome Plataforma" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.parceiro.identificacao) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.parceiro.identificacao]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_a_form_item, { label: "Título - Google e Buscadores" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.parceiro.tituloSeo) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.parceiro.tituloSeo]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_a_form_item, { label: "Descrição - Página Inicial" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_textarea, {
                          value: _ctx.state.parceiro.descricaoSeo,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.parceiro.descricaoSeo) = $event)),
                          "show-count": ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_a_form_item, { label: "Tipo Pessoa" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_tipo_pessoa, {
                          valor: _ctx.state.parceiro.tipoPessoa,
                          "onUpdate:valor": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.parceiro.tipoPessoa) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  ((_ctx.state.parceiro.tipoPessoa === 1))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createVNode(_component_a_form_item, { label: "CPF" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_cpf, {
                              valor: _ctx.state.parceiro.cpfCnpj,
                              "onUpdate:valor": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.parceiro.cpfCnpj) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  ((_ctx.state.parceiro.tipoPessoa === 2))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createVNode(_component_a_form_item, { label: "CNPJ" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_cnpj, {
                              onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.consultaCnpj())),
                              valor: _ctx.state.parceiro.cpfCnpj,
                              "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.parceiro.cpfCnpj) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_a_form_item, {
                      label: _ctx.state.parceiro.tipoPessoa === 1?'Nome':'Razão Social'
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.parceiro.nomeRazaoSocial) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.parceiro.nomeRazaoSocial]
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ])
                ]),
                ((_ctx.state.parceiro.tipoPessoa === 2))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_a_form_item, { label: "Responsável" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.parceiro.nomeResponsavel) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.parceiro.nomeResponsavel]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_a_form_item, { label: "E-mail" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_email, {
                          valor: _ctx.state.parceiro.email,
                          "onUpdate:valor": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.parceiro.email) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_a_form_item, { label: "Telefone" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_telefone, {
                          valor: _ctx.state.parceiro.telefone,
                          "onUpdate:valor": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.parceiro.telefone) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_a_form_item, { label: "WhatsApp" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_telefone, {
                          valor: _ctx.state.parceiro.whatsapp,
                          "onUpdate:valor": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.parceiro.whatsapp) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_a_form_item, { label: "Mensagem ao clicar no WhatsApp" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.parceiro.whatsappMensagem) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.parceiro.whatsappMensagem]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_component_a_form_item, { label: "CEP" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_cep, {
                          onBlur: _cache[14] || (_cache[14] = ($event: any) => (_ctx.consultaCep())),
                          valor: _ctx.state.parceiro.cep,
                          "onUpdate:valor": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.parceiro.cep) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(_component_a_form_item, { label: "Endereço/Logradouro" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.parceiro.endereco) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.parceiro.endereco]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_component_a_form_item, { label: "Número" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.parceiro.numero) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.parceiro.numero]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createVNode(_component_a_form_item, { label: "Complemento" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.parceiro.complemento) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.parceiro.complemento]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createVNode(_component_a_form_item, { label: "Bairro" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.parceiro.bairro) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.parceiro.bairro]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createVNode(_component_a_form_item, { label: "Cidade/UF" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_cidade, {
                          codigo: _ctx.state.parceiro.codigoCidade,
                          "onUpdate:codigo": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.parceiro.codigoCidade) = $event))
                        }, null, 8, ["codigo"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ]))
}